import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section, Reveal } from '../shared/Section';
const chips = [{
  value: '6 semanas',
  label: 'hasta el cambio'
}, {
  value: '0 pastillas',
  label: 'hoy'
}, {
  value: '4 años',
  label: 'de dolor atrás'
}];
export function FeaturedStory() {
  return <Section id="historia" bg="bg-sand-200/50" data-id="element-38" data-mp="g9k47tn61m51">
      <Reveal data-id="element-39" data-mp="gav6tq4vknuk">
        <div className="mb-8 flex items-center justify-center gap-2 text-center" data-id="element-40" data-mp="g77g0yqtefjj">
          <StarIcon className="h-5 w-5 fill-clay-500 text-clay-500" data-id="element-41" data-mp="1dupyx2e6wy19" />
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-clay-600" data-id="element-42" data-mp="18z0vgnz1uwzo">
            Historia real de transformación
          </p>
        </div>
      </Reveal>

      <Reveal index={1} data-id="element-43" data-mp="z01nl7m3z5dq">
        <div className="grid items-center gap-8 rounded-3xl border border-sand-200 bg-white p-6 shadow-xl shadow-forest-800/5 sm:p-8 md:grid-cols-[0.8fr_1.2fr] md:gap-10" data-id="element-44" data-mp="yyqi93d0lpki">
          <div data-id="element-45" data-mp="3jp92oe0xxutr">
            <div className="overflow-hidden rounded-2xl" data-id="element-46" data-mp="3jopkcw7dp4f7">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/a27cc29f-4b86-4b81-b5fb-07f14bea5b31.jpg" alt="Sofía Torres, alumna del programa, sonriente en su casa" className="aspect-square w-full object-cover" data-id="element-47" data-mp="1qefnshsmm2nf" />
            </div>
            <div className="mt-5" data-id="element-48" data-mp="1lf2v3gf2q1cx">
              <p className="font-display text-xl font-semibold text-forest-800" data-id="element-49" data-mp="1le1det3jygm8">Sofía Torres</p>
              <p className="text-sm font-medium text-clay-600" data-id="element-50" data-mp="17n63ddhbhth2">Alumna estrella</p>
              <p className="mt-1 text-sm text-forest-700/60" data-id="element-51" data-mp="1cewfnozterb4">
                Rosario, Argentina · Sin lumbar en 6 semanas · Hábito de por vida
              </p>
            </div>
          </div>

          <div data-id="element-52" data-mp="12o1vqra1k3su">
            <blockquote className="font-display text-lg leading-relaxed text-forest-800 sm:text-xl" data-id="element-53" data-mp="12pmpwfsg1kq6">
              “Tenía dolor lumbar crónico hace casi 4 años. Probé de todo: fisio, osteopatía,
              pastillas, calor. Algo aliviaba unos días y volvía. Con este programa entendí por
              primera vez por qué me dolía y qué hacer específicamente. En la segunda semana ya
              dormía mejor. En seis semanas dejé de pensar en el dolor como parte de mi vida. Hoy
              hago las rutinas todas las mañanas y me siento dueña de mi cuerpo otra vez.”
            </blockquote>
            <p className="mt-5 text-sm leading-relaxed text-forest-700/70" data-id="element-54" data-mp="2gpr773j9qjdr">
              Sofía es docente, trabaja 8 horas sentada y nunca había hecho movilidad de forma
              estructurada. Hoy es nuestra alumna más destacada y la prueba de que el método
              funciona para cualquier persona, sin importar su punto de partida.
            </p>

            <div className="mt-6 grid grid-cols-3 gap-3" data-id="element-55" data-mp="30cp647ozt00e">
              {chips.map(c => <div key={c.label} className="rounded-xl bg-forest-50 px-3 py-3 text-center" data-id="element-56" data-mp="1syltatww2163">
                  <p className="font-display text-base font-semibold text-forest-800 sm:text-lg" data-id="element-57" data-mp="1oxa0ygmmr1u7">
                    {c.value}
                  </p>
                  <p className="mt-0.5 text-xs text-forest-700/60" data-id="element-58" data-mp="4gj1kom024z1">{c.label}</p>
                </div>)}
            </div>
          </div>
        </div>
      </Reveal>
    </Section>;
}